import { ROUTES } from '@/constants/routes'

// Shared between the router's React.lazy() wrappers and hover-prefetch
// (lib/routePrefetch.ts) so a hovered nav item warms the exact chunk the
// router will request. Lives in its own module to avoid a router ↔
// routePrefetch import cycle.
export const routeImporters = {
  [ROUTES.PROFILES]: () => import('@/views/ProfilesView'),
  [ROUTES.PROFILE_DETAIL]: () => import('@/views/ProfileDetailView'),
  [ROUTES.SOS]: () => import('@/views/SOSView'),
  [ROUTES.LOCATION]: () => import('@/views/LocationView'),
  [ROUTES.SESSIONS]: () => import('@/views/SessionsView'),
  [ROUTES.COMMUNITY]: () => import('@/views/CommunityView'),
  [ROUTES.FIND_HELP]: () => import('@/views/FindHelpView'),
  [ROUTES.MESSAGING]: () => import('@/views/MessagingLayout'),
  [ROUTES.SETTINGS]: () => import('@/views/SettingsView'),
  [ROUTES.ORG]: () => import('@/views/OrgView'),
  [ROUTES.ORG_TEAM]: () => import('@/views/OrgTeamView'),
  [ROUTES.COMMAND_CENTER]: () => import('@/views/CommandCenterView'),
  [ROUTES.MISSION_CONTROL]: () => import('@/views/MissionControlView'),
  [ROUTES.FEEDBACK]: () => import('@/views/FeedbackView'),
  [ROUTES.HAZARDS]: () => import('@/views/HazardsView'),
  [ROUTES.WEATHER]: () => import('@/views/WeatherView'),
  [ROUTES.QR]: () => import('@/views/QRView'),
} as const
